<template>
    <b-row>
        <b-col lg="6" v-for="item in form" :key="item" class="text-center">
            <b-card>
                <div class="monobank-card" >
                    <div  class="monobank-card-image-block black-card" >
                        <div>
                            <img src="https://online.skyservice.pro/img/apps/monobank/cards/black-card.png" class="monobank-card-image" style="width: 100%">
                            <div class="monobank-card-number copy" @click="copy(item.app_data.selectedCard.maskedPan[0])">{{item.app_data.selectedCard.maskedPan[0]}} </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import {copy} from '@/usabilityScripts/copy.js'

export default ({
    props: ['obj'],
    components: {  },
    data() {
        return{
            // market_id: "",
            // sellup_id: "",
            form: "",
            // providers: {},
            // ifMain: true,
            // ifWeb: true
        }
    },
    created(){
        this.form = this.obj
    },
    methods: {
        copy(item){
            // копіювання
            if(copy(item) == true) {
                this.$toast.success(this.$t('Copied'));
            } else {
                this.$toast.error(`Fucking mistake, contact Borys`);
            }
            return
        },
    }
})
</script>

<style scoped>
.black-card .monobank-card-number {
    color: #fff;
}
.monobank-card-number {
    position: absolute;
    letter-spacing: 5px;
    font-size: 13px;
    color: #000;
    left: 0;
    right: 0;
    text-align: center;
    top: 50%;
}
</style>